import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

// Dashboard pages
import Dashboard from "@/pages/Dashboard/Dashboard.vue";
import OpenUploads from "@/pages/Dashboard/OpenUploads.vue";
import PipescannerResults from "@/pages/Dashboard/PipescannerResults.vue";
import PipescannerDetails from "@/pages/Dashboard/PipescannerDetails.vue";
import PipescannerEdit from "@/pages/Dashboard/PipescannerEdit.vue";
import PipescannerAnalyser from "@/pages/Dashboard/PipescannerAnalyser.vue";
import Tools from "@/pages/Dashboard/Tools.vue";
import ToolsAdd from "@/pages/Dashboard/ToolsAdd.vue";
import ToolsEdit from "@/pages/Dashboard/ToolsEdit.vue";

const routes = [
  {
    path: "/",
    component: DashboardLayout,
    redirect: "/",
    children: [
      {
        path: "/",
        name: "Dashboard",
        component: Dashboard,
      },
      {
        path: "/open-uploads",
        name: "Open Uploads",
        component: OpenUploads,
      },
      {
        path: "/pipescanner-results",
        name: "Pipescanner Results",
        component: PipescannerResults,
      },
      {
        path: "/pipescanner-details",
        name: "Pipescan Details",
        component: PipescannerDetails,
      },
      {
        path: "/pipescanner-edit",
        name: "Pipescan Edit",
        component: PipescannerEdit,
      },
      {
        path: "/pipescanner-analyser",
        name: "Pipescanner Analyser",
        component: PipescannerAnalyser,
      },
      {
        path: "/tools",
        name: "Tools",
        component: Tools,
      },
      {
        path: "/add-tools",
        name: "Add Tools",
        component: ToolsAdd,
      },
      {
        path: "/edit-tool",
        name: "Edit Tool",
        component: ToolsEdit,
      }
    ],
  },
];
export default routes;
